// extracted by mini-css-extract-plugin
export var notFoundHeadline = "_404-module--not-found-headline--2aNjC";
export var notFoundHeadlineColor = "_404-module--not-found-headline-color--Fu1lC";
export var notFoundGoHome = "_404-module--not-found-go-home--2L4OM";